import * as R from 'ramda'
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'
import momentNs from 'moment'
const moment = momentNs

export function convertStructToMoment(date: NgbDateStruct | NgbDate) {
  if (!date || !R.is(Number, date.day) || !R.is(Number, date.day) || !R.is(Number, date.day)) {
    return null
  }

  return moment(`${date.year}-${date.month}-${date.day}`, 'YYYY-MM-DD')
}
